export const PIC_VIEW_TYPE = {
  DEFAULT: '_prototype_default',
  BLACK: '_prototype_black',
  GRAY: '_prototype_gray',
  VERTICAL: '_prototype_vertical',
  HORIZONTAL: '_prototype_horizontal',
  HORIZONTAL_stretch: '_prototype_horizontal',
}
